/* eslint-disable */

export default {
    init() {
        console.log("hewre")
        const videoButtons = document.querySelectorAll("[class*='video-button']");
        videoButtons.forEach((videoButton) => {
            const videoPlayer = videoButton.nextSibling.nextSibling;

            videoButton.addEventListener("click", (e) => {
                videoButton.style.display = "none";
                videoPlayer.play();
                videoPlayer.setAttribute("controls","controls");
                videoPlayer.nextSibling.nextSibling.style.display = "none";
            })
            


            videoPlayer.onloadedmetadata = function() {
                let duration = convertSeconds(this.duration);

                videoPlayer.nextSibling.nextSibling.innerHTML = duration;
            }
        })
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
  };
  

function convertSeconds(sec) {
    var m = Math.floor(sec / 60);
    var s  = (sec % 60).toFixed(0);
    return (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
}


// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateVideoGallery.js